/**
 * @generated SignedSource<<ee9b1c43ee52b2896dc1936afd8576fd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GroupTableBody_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Rows_rules">;
  readonly " $fragmentType": "GroupTableBody_rules";
};
export type GroupTableBody_rules$key = {
  readonly " $data"?: GroupTableBody_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GroupTableBody_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Rows_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "ff07da1a4c4e233045c0b3166944b4fb";

export default node;
